import React, { useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  Main,
  About,
  Produce,
  Developers,
  Projects,
  Services,
  ServiceSingle,
  PageSingle,
  ProjectSingle,
  MapPage,
  Requisites,
  ErrorPage,
  Sitemap,
} from "../pages";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

const MainRouter = ({ contact }) => {
  const ROUTES = [
    {
      path: "/",
      element: <Main contact={contact} />,
    },
    {
      path: "/about",
      element: <About contact={contact} />,
    },
    {
      path: "/produce",
      element: <Produce contact={contact} />,
    },
    {
      path: "/developers",
      element: <Developers contact={contact} />,
    },
    {
      path: "/pages/:slug",
      element: <PageSingle contact={contact} />,
    },
    {
      path: "/pages/:slug/edit",
      element: <PageSingle contact={contact} />,
    },
    {
      path: "/projects",
      element: <Projects contact={contact} />,
    },
    // { path: '/projects/:slug', element: <ProjectSingle setCurrentCity={setCurrentCity} contact={contact} /> },
    // { path: '/projects/:slug/edit', element: <ProjectSingle setCurrentCity={setCurrentCity} contact={contact} /> },
    {
      path: "/services",
      element: <Services contact={contact} />,
    },
    {
      path: "/req",
      element: <Requisites  />,
    },
    {
      path: "/services/:slug",
      element: (
        <ServiceSingle contact={contact} />
      ),
    },
    {
      path: "/contacts",
      element: <MapPage contact={contact} />,
    },
    { path: "/sitemap", element: <Sitemap /> },
    {
      path: "*",
      element: (
        <ErrorPage
          contact={contact}
          status={404}
        />
      ),
    },
  ];

  const Wrapper = ({ children }) => {
    const location = useLocation();

    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);

    return children;
  };

  return (
    <>
      <Header contact={contact} />

      <main>
        <Wrapper>
          <Routes>
            {ROUTES.map((route) => {
              if (route.path === "*") {
                return <Route path={route.path} element={route.element} />
              } else {
                return (
                  <>
                    <Route path={route.path} element={route.element} />
                  </>
                );
              }
            })}
          </Routes>
        </Wrapper>
      </main>

      <Footer contact={contact} />
    </>
  );
};

export default MainRouter;
